import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'; // Import QueryClient and Provider
import App from './App';
import { AuthProvider } from './lib/auth/AuthContext';
import { ThemeProvider } from './components/ThemeProvider';
import '@pagespeedify/ui/styles/globals.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Failed to find the root element with ID 'root'. Check your index.html file.");
}

// Create a client instance (outside the render function)
const queryClient = new QueryClient();

// Only enable React.StrictMode in development for extra checks. In production
// React ignores the extra development-only checks, but rendering StrictMode
// conditionally makes the intention explicit and avoids any confusion.
const isDev = typeof import.meta !== 'undefined' ? Boolean((import.meta as any).env?.DEV) : process.env.NODE_ENV !== 'production';

const AppRoot = (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <ThemeProvider defaultTheme="dark">
        <AuthProvider> {/* AuthProvider is now inside BrowserRouter */}
          <App />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

ReactDOM.createRoot(rootElement).render(
  isDev ? <React.StrictMode>{AppRoot}</React.StrictMode> : AppRoot
);